<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="75vw" append-to-body :before-close="handleClose">
    <div style="overflow: auto; height: 65vh; width:100%">
      <el-form :model="form " inline label-width="100px">
        <el-form-item prop="vipName" label="门店名称:" v-if="title=='明细'">
          <div class="form-width-ms">{{form.storeName}}</div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="单号:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.refundNum}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="退款时间:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.refundDate}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="审核时间:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.auditDate | initDate }}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="手机号码:">
          <label slot="label">手&nbsp;&nbsp;机&nbsp;&nbsp;号</label>
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.mobilePhone}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="vipName" label="会员名字:">
          <div class="form-width-ms">{{form.memberName}}</div>
        </el-form-item>
        <el-form-item prop="vipName" label="身份证号:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.manageIdentity}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechargeTypeNum" label="充值编码:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.rechargeTypeNum}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechargeTypeName" label="充值账户:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.rechargeTypeName}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="rechDate" label="账户余额:">
          <div class="form-width-ms">{{form.cardRestMoney}}</div>
        </el-form-item>

        <el-form-item label="赔偿金额:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{form.recCompensation}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="refundMoneys" label="计划退款:" v-if="sessionStorageData.refundCard&&title=='修改'">
          <div class="form-width-ms">{{form.refundMoneys}}</div>
        </el-form-item>
        <el-form-item label="实际退款:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              {{form.refundMoney}}
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="give" label="赠送退款:">
          <div class="form-width-ms">
            {{form.refundGiftMoneys}}
            <el-button size="mini" type="text" @click="handleStoreDeductions" v-if="isTrue">扣款详情</el-button>
          </div>
        </el-form-item>

        <el-form-item label="收款银行:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundType}}</div>
          </div>
        </el-form-item>
        <el-form-item label="收款账户:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundAccount}}</div>
          </div>
        </el-form-item>
        <el-form-item label="收款人:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{payee}}</div>
          </div>
        </el-form-item>

        <el-form-item prop="cause" label="退款备注:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundReason}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="cause" label="附带文件:" required>
          <div class="flex">
            <div style="width:100px;cursor: pointer; margin:0 5px;" v-for="(item,index) in  fileList" :key="index">
              <el-image @click="(url = item.url,openImageDialog=true,urlForm = item)" :src='item.url'>
                <div slot="error" class="image-slot">
                  <div title="点击下载文件" style="cursor: pointer;width:300px;" @click="directDown(item)">{{item.fileName}}</div>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <div class=" flex justify-start align-start flex-wrap padding-top margin-left-lg">
          <staffsles ref="staffsles" @staffslesData="staffslesData"></staffsles>
          <admin ref="admin" @adminData="adminData"></admin>
          <manager ref="manager" @managerData="managerData"></manager>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="cancel()">关闭</el-button>
    </span>
    <storeChargeDetails ref="storeChargeDetails"></storeChargeDetails>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="图片预览" :visible.sync="openImageDialog" append-to-body>
      <el-image style="height: 60vh;width:100%" :src="url" fit="contain"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" plain @click="openImageDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmImage(openImageDialog=false)">下 载</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { selectOne, refpage, refOrderDownload } from "@/api/eashier.js";
import { partten } from "../../../../../partten/index.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
import storeChargeDetails from "./storeChargeDetails.vue";
export default {
  filters:{
    initDate:function(time){
      if(time){
        let date = new Date(time);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        let strDate = Y + M + D + h + m + s;
        return strDate
      }else return '--'
    }
  },
  components: {
    staffsles,
    manager,
    admin,
    storeChargeDetails
  },
  data() {
    return {
      detailDialog: false,
      activeNames: "员工",
      rowfromWidth: "80px",
      sessionStorageData: {}, //门店参数集合
      openImageDialog: false,
      url: "",
      refundType: null,
      refundAccount: null,
      payee: null,
      refundReason: null,
      fileData: [],
      filesList: [],
      fileList: [],
      title: "", //弹窗标题
      form: {}, //主对象
      urlForm: {},
    };
  },
  computed:{
    isTrue(){
      if(this.form.rechargeAccountGiveList){
        if(this.form.rechargeAccountGiveList.length){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    }
  },
  methods: {
    handleStoreDeductions(){
      this.$refs.storeChargeDetails.show(this.form)
    },
    //下载文件方法
    directDown(item) {
      let url = {
        fileName: item.fileName,
        filePath: item.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = item.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    confirmImage() {
      let url = {
        fileName: this.urlForm.fileName,
        filePath: this.urlForm.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = this.urlForm.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.fileList = [];
      this.detailDialog = false;
      this.fileData = [];
    },
    //自定义文件上传拦截方法
    uploadFile(file) {
      this.fileData.append("fileList", file.file);
    },
    setStaff() {
      var that = this;
      this.$nextTick(() => {
        console.log(that.form);
        that.$refs.staffsles.show(that.form.staffLists);
        that.$refs.admin.show(that.form.adminList);
        that.$refs.manager.show(that.form.managerList);
      });
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.staffLists = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.detailDialog = false;
      this.$emit("detailData");
    },
    //组件传值
    show(form, title) {
      this.title = title;
      this.detailDialog = true;
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.getData(form);
    },
    getData(form) {
      refpage({
        refundNum: form.refundNum,
        refundOrderId: form.id,
        storeId: form.storeId,
      }).then((res) => {
        if (res.code == "000000") {
          if (res.pageInfo.total == 0) {
            this.$alert("未找到相关明细", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "confirmbtnFalses",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
          } else {
            this.form = res.pageInfo.list[0];
            this.form.auditDate = form.auditDate //仅审核时间
            console.log(this.form.refundRechargeList)
            if(this.form.refundRechargeList){
              this.form.refundGiftMoneys =  (eval(this.form.refundRechargeList.map(item=>item.refundGiftMoney?item.refundGiftMoney*1:0).join("+")))
              this.form.refundGiftMoneys = (this.form.refundGiftMoneys || 0)
            }
            this.form.rechargeAccountGiveList = ( this.form.refundRechargeList || [])
            this.form.refundMoneys = this.form.recRefundMoney;
            this.form.refundMoney = this.form.recRefundMoney;
            this.refundType = form.refundType;
            this.refundAccount = form.refundAccount;
            this.payee = form.payee;
            this.refundReason = form.refundReason;
            let staffLists = [];
            res.pageInfo.list[0].entities.forEach((item) => {
              let items = {
                ratio: item.saleRatio,
                staffNames: item.brandNumber + "--" + item.saleStaffName,
                id: item.saleStaffId,
                staffName: item.saleStaffName,
                brandNumber: item.brandNumber,
                identityCard: item.saleIdentityCard,
              };
              staffLists.push(items);
            });
            this.form.staffLists = staffLists;
            this.fileList = res.pageInfo.list[0].fileLists;
            this.fileList.forEach((item) => {
              item.url = partten.https + item.filePath + "/" + item.fileName;
            });
            selectOne({ orderType: 4, orderNum: this.form.refundNum }).then(
              (res) => {
                if (res.code == "000000") {
                  let managerList = [];
                  let adminList = [];
                  res.rows.forEach((item) => {
                    if (item.staffType == 0) {
                      item.staffNames =
                        item.brandNumber + "--" + item.staffName;
                      managerList.push(item);
                    }
                    if (item.staffType == 1) {
                      item.staffNames =
                        item.brandNumber + "--" + item.staffName;
                      adminList.push(item);
                    }
                  });
                  if (managerList.length == 0) {
                    managerList.push({ ratio: 100 });
                  }
                  if (adminList.length == 0) {
                    adminList.push({ ratio: 100 });
                  }
                  if (this.form.staffLists.length == 0) {
                    this.form.staffLists.push({ ratio: 100 });
                  }
                  this.form.managerList = managerList;
                  this.form.adminList = adminList;
                  this.setStaff();
                } else {
                  this.$alert(res.message, "加载门店高管", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                    center: true,
                    callback: (action) => {},
                  });
                }
              }
            );
          }
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    endRecRefundMoney() {
      if (this.form.refundMoney > this.form.cardRestMoney) {
        this.$message.error({
          message: "退款金额不能大于账户余额",
        });
      } else {
      }
    },
    subStaffRatio() {},
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/eashier/refundRecharge/components/detail.vue